import { Select } from 'antd';
import React from 'react';





const Search = ({search, handleChange}) => {
  return (
    <div className='border'>
      <Select
        mode='tags'
        size={'middle'}
        placeholder='Search'
        value={search}
        onChange={handleChange} 
        className='w-full'
        variant='borderless'
        dropdownStyle={{visibility: 'hidden'}}
      />
    </div>
  )
}

export default Search;